// Shared by C · Collection grid and C · Search results (both use the .c-col shell).
const url = new URL(window.location.href);
if (url.hash) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    },
    { once: true }
  );
}

const getCColScope = (root) =>
  root?.matches?.('.c-col') ? root : root?.querySelector?.('.c-col') || document.querySelector('.c-col');

const openFiltersDrawer = () => {
  const drawer = document.getElementById('filters-drawer');
  if (!drawer) return;

  if (typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  const dialog = drawer.querySelector('dialog');
  if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

  document.documentElement.setAttribute('scroll-lock', '');
  dialog.showModal();
  drawer.setAttribute('open', '');
};

const initCFilterDrawerControls = (root) => {
  const scope = getCColScope(root);
  if (!scope) return;

  scope.querySelectorAll('.facets-toggle__button').forEach((button) => {
    const handler = button.getAttribute('on:click');
    if (!handler?.includes('#filters-drawer/open')) return;
    if (button.dataset.cFilterDrawerReady === 'true') return;
    button.dataset.cFilterDrawerReady = 'true';

    button.addEventListener('click', () => {
      requestAnimationFrame(() => {
        const drawer = document.getElementById('filters-drawer');
        const dialog = drawer?.querySelector('dialog');
        if (drawer?.hasAttribute('open') || dialog?.open) return;
        openFiltersDrawer();
      });
    });
  });
};

const initCFilterStickyStrip = (root) => {
  const scope = getCColScope(root);
  if (!scope) return;

  scope.querySelectorAll('.facets-toggle').forEach((strip) => {
    if (strip.dataset.cFilterStickyReady === 'true') return;
    strip.dataset.cFilterStickyReady = 'true';

    const updateStuck = () => {
      const stickyTop = parseFloat(getComputedStyle(strip).top) || 0;
      strip.classList.toggle('is-stuck', strip.getBoundingClientRect().top <= stickyTop + 1);
    };

    updateStuck();
    window.addEventListener('scroll', updateStuck, { passive: true });
    window.addEventListener('resize', updateStuck);
  });
};

const initCCollectionFilters = (root) => {
  initCFilterStickyStrip(root);
  initCFilterDrawerControls(root);
};

initCCollectionFilters(document);
document.addEventListener('shopify:section:load', (event) => initCCollectionFilters(event.target));
